export const toTitleCase = (str) => {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export const formatNumber = (n: number) => {
  return new Intl.NumberFormat("en-AU", {
    maximumSignificantDigits: 5,
  }).format(Math.ceil(n));
};
